const faqItems = [
  {
    q: "Apakah biaya sudah termasuk instalasi?",
    a: "Ya, semua paket standar sudah termasuk pemasangan dasar, setting online, dan training singkat penggunaan aplikasi.",
  },
  {
    q: "Berapa lama proses pemasangan?",
    a: "Untuk 2–4 channel biasanya selesai dalam 1 hari kerja. Proyek besar bisa memerlukan 1–2 hari tambahan.",
  },
  {
    q: "Apakah ada garansi?",
    a: "Ya, garansi resmi pabrikan 1 tahun dan garansi jasa pemasangan 30 hari.",
  },
  {
    q: "Apakah bisa survei lokasi terlebih dahulu?",
    a: "Bisa, survei gratis untuk area jangkauan kami. Hubungi WhatsApp untuk jadwal.",
  },
  {
    q: "Bisakah CCTV diakses dari HP?",
    a: "Tentu, kami bantu setup aplikasi resmi dari merek seperti Hikvision, Dahua, EZVIZ, dan lainnya.",
  },
];

export default faqItems;
